import(/* webpackMode: "eager" */ "/app/src/modules/contact/components/views/ContactView.tsx")